import { render, staticRenderFns } from "./EventAttendees.vue?vue&type=template&id=0fd6d8ba&scoped=true&"
import script from "./EventAttendees.vue?vue&type=script&lang=js&"
export * from "./EventAttendees.vue?vue&type=script&lang=js&"
import style0 from "./EventAttendees.vue?vue&type=style&index=0&id=0fd6d8ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd6d8ba",
  null
  
)

export default component.exports